import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-student-ranking',
  templateUrl: './student-ranking.component.html',
})
export class DashboardV2StudentRankingComponent {
  @Input() tabs: string[] = [];
  @Input() activeTab = '';
  @Input() ranking: any[] = [];
  @Input() loading = false;
  @Input() error = '';
  @Output() refresh = new EventEmitter<void>();
  @Output() tabChange = new EventEmitter<string>();
  @Output() studentClick = new EventEmitter<any>();

  selectedRankingDetail: any = null;

  openRankingDetails(student: any, event: Event): void {
    event.stopPropagation();
    this.selectedRankingDetail = student;
  }

  closeRankingDetails(): void {
    this.selectedRankingDetail = null;
  }

  @HostListener('document:keydown.escape')
  closeRankingDetailsOnEscape(): void {
    this.closeRankingDetails();
  }
}
